<p-toast></p-toast>

<div class="hidden-docs-page">
  <h2>Hidden documents</h2>
  <p class="hidden-docs-note">
    Shows what would be hidden once the DocumentList access-group filter is switched on. Today nobody is blocked by it.
    Exception: the "Unlisted documents" section below shows documents that really are missing from every list for
    everyone today, for reasons that are not the ladder.
  </p>

  <div class="hidden-docs-selection">
    <div class="hidden-docs-field">
      <label for="hd-login">Login</label>
      <p-dropdown inputId="hd-login" [options]="logins" [(ngModel)]="selectedLogin" optionLabel="label" filterBy="label"
                  [filter]="true" [showClear]="true" placeholder="Select a person / login" styleClass="hidden-docs-login">
        <ng-template let-l pTemplate="item">
          <span>{{l.label}}</span>
          <p-tag *ngIf="!l.resolvableByFence" severity="warning" value="cannot match a Keycloak user ID" styleClass="hidden-docs-chip"></p-tag>
          <p-tag *ngIf="l.newcomerLabelled" severity="warning" value="labelled newcomer but group ≥ 10000" styleClass="hidden-docs-chip"></p-tag>
        </ng-template>
      </p-dropdown>
      <div class="hidden-docs-warnings" *ngIf="selectedLogin">
        <p-tag *ngIf="!selectedLogin.resolvableByFence" severity="warning" value="Login cannot match a Keycloak user ID"></p-tag>
        <p-tag *ngIf="selectedLogin.newcomerLabelled" severity="warning" value="Labelled newcomer but group ≥ 10000"></p-tag>
      </div>
    </div>

    <div class="hidden-docs-field">
      <label for="hd-from">From date (required)</label>
      <p-calendar inputId="hd-from" [(ngModel)]="fromDate" dateFormat="dd.mm.yy" [showIcon]="true" [firstDayOfWeek]="1"></p-calendar>
      <div class="hidden-docs-presets">
        <p-button label="3 months" size="small" [text]="true" (onClick)="presetMonths(3)"></p-button>
        <p-button label="1 year" size="small" [text]="true" (onClick)="presetMonths(12)"></p-button>
        <p-button label="Current era" size="small" [text]="true" (onClick)="presetEra()" pTooltip="Everything from 1998-01-01"></p-button>
      </div>
    </div>

    <div class="hidden-docs-field">
      <label for="hd-ladder">Ladder override (what-if)</label>
      <p-inputNumber inputId="hd-ladder" [(ngModel)]="ladderOverride" [useGrouping]="false" [min]="0" [max]="2147483647" placeholder="optional"></p-inputNumber>
      <small>What-if: overrides the login's group.<span *ngIf="overrideActive && selectedLogin"> The override wins over the selected login.</span></small>
    </div>

    <div class="hidden-docs-field">
      <label for="hd-types">Document types</label>
      <p-multiSelect inputId="hd-types" [options]="docTypes" [(ngModel)]="selectedDocTypes" optionLabel="DOCNAME1" dataKey="DOCTYPEID"
                     placeholder="All types" [maxSelectedLabels]="1" selectedItemsLabel="{0} types selected"></p-multiSelect>
    </div>

    <div class="hidden-docs-actions">
      <p-button label="Load" icon="pi pi-search" [disabled]="!canLoad" (onClick)="onLoad()"></p-button>
    </div>
  </div>

  <div *ngIf="loading" class="hidden-docs-loading"><i class="pi pi-spin pi-spinner"></i> Loading…</div>

  <ng-container *ngIf="result">
    <div class="hidden-docs-summary">
      <div class="hidden-docs-message" *ngIf="!result.target.resolvable">{{result.message}}</div>

      <ng-container *ngIf="result.target.resolvable">
        <div *ngIf="mainStale">
          <p-tag severity="warning" value="These results are from a previous Load; the latest Load failed. Press Load to retry."></p-tag>
        </div>
        <div>
          Target: <strong>{{result.target.login || 'what-if'}}</strong>, group <strong>{{result.target.ladder}}</strong>
          ({{result.target.source === 'override' ? 'from the ladder override' : 'from the login'}}) ·
          window from {{result.window.fromDate}}{{result.window.toDate ? ' to ' + result.window.toDate : ''}} · company {{result.window.mainCompany}}
        </div>
        <div><strong>{{result.summary.hidden | number}}</strong> hidden of {{result.summary.totalInWindow | number}} listed documents</div>
        <div class="hidden-docs-chips">
          <p-tag *ngFor="let code of reasonCodes" [value]="reasonLabel(code) + ': ' + (result.summary.byReason[code] | number)"
                 [pTooltip]="reasonTooltip(code)" severity="info"></p-tag>
        </div>
        <div class="hidden-docs-chips">
          <span *ngFor="let t of topTypes" class="hidden-docs-type">{{t.name || ('type ' + t.docTypeId)}}: {{t.hidden | number}}</span>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="result.target.resolvable">
      <ng-container *ngIf="!mainStale">
      <p-toolbar>
        <ng-template pTemplate="right">
          <p-button label="XLSX" icon="pi pi-file-excel" styleClass="p-button-info" (onClick)="onExportData()" [disabled]="!rows.length"
                    pTooltip="Export the current page"></p-button>
        </ng-template>
      </p-toolbar>

      <p-table [value]="rows" [lazy]="true" [lazyLoadOnInit]="false" (onLazyLoad)="onPage($event)" [loading]="loading"
               [paginator]="true" paginatorPosition="both" [rows]="rowsPerPage" [first]="first" [totalRecords]="result.summary.hidden"
               [rowsPerPageOptions]="PAGE_SIZES" [showCurrentPageReport]="true"
               currentPageReportTemplate="Showing {first} to {last} of {totalRecords} hidden documents"
               styleClass="p-datatable p-datatable-gridlines p-datatable-striped" dataKey="DOCID" [rowHover]="true"
               [tableStyle]="{ 'min-width': '100rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Документ</th>
            <th>Номер</th>
            <th>Дата</th>
            <th>Продавец</th>
            <th>Автор</th>
            <th>Контрагент</th>
            <th>Сумма</th>
            <th>Оплачено</th>
            <th>Отгружено</th>
            <th class="do-not-overlay-text">Пр. продавца</th>
            <th class="do-not-overlay-text">Пр. покупателя</th>
            <th>Why hidden</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dlCurr>
          <tr [class.futuredocs]="dlCurr.fd"
              [class.grayout]="dlCurr.go"
              [class.underline]="dlCurr.ps"
              [class.strikeout]="dlCurr.fs"
              [class.partiallypaiddoc]="dlCurr.pp"
              [class.notpaiddoc]="dlCurr.np"
              [class.fullypaiddoc]="dlCurr.fp"
              [class.todaydocuments]="dlCurr.td"
              [class.proformadoc]="(dlCurr.DOCTYPEID == 12)"
              [class.inorderdoc]="(dlCurr.DOCTYPEID == 2)"
              [class.banktransferdoc]="(dlCurr.DOCTYPEID == 9)"
              [class.purchorderdoc]="(dlCurr.DOCTYPEID == 10)"
              [class.yellowdoc]="(dlCurr.DOCTYPEID == 14)"
              [class.specdoc]="(dlCurr.DOCTYPEID == 7)"
              [class.shiporderdoc]="(dlCurr.DOCTYPEID == 4)"
              [class.invoicedoc]="(dlCurr.DOCTYPEID == 1)">
            <td>{{dlCurr.DOCNAME}} <p-tag *ngIf="isVoided(dlCurr)" severity="danger" value="Voided"></p-tag></td>
            <td><a href="javascript:void(0)" (click)="openDocument(dlCurr)">{{dlCurr.DOCNUMBER}}</a></td>
            <td class="CellWithComment">
              <span class="CellComment">{{dlCurr.DOCVALDATE | date:'dd.MM.yyyy'}}<br />{{dlCurr.DOCEXPDATE | date:'dd.MM.yyyy'}}</span>{{dlCurr.DOCDATE | date:'dd.MM.yyyy'}}
            </td>
            <td>{{dlCurr.LOCALCOMP}}</td>
            <td>{{dlCurr.AUTHOR}}</td>
            <td class="CellWithComment">
              <span class="CellComment">{{dlCurr.CLIENTSNAME}}</span>
              <a href="javascript:void(0)" (click)="openClient(dlCurr)">{{dlCurr.PARTNERNAME}}</a>
            </td>
            <td class="hidden-docs-num">{{dlCurr.DOCSUM | number:'1.2-2'}}</td>
            <td class="hidden-docs-num">{{dlCurr.PAYDSUM | number:'1.2-2'}}</td>
            <td class="hidden-docs-num">{{dlCurr.SHIPSUM | number:'1.2-2'}}</td>
            <td>{{dlCurr.DOCNOTE1}}</td>
            <td>{{dlCurr.DOCNOTE2}}</td>
            <td>
              <p-tag *ngFor="let code of dlCurr.reasons" [value]="reasonLabel(code)" [pTooltip]="reasonTooltip(code)" severity="warning" styleClass="hidden-docs-chip"></p-tag>
              <span class="hidden-docs-detail">{{reasonDetail(dlCurr)}}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="12">Nothing would be hidden from this login in this window.</td></tr>
        </ng-template>
      </p-table>
      </ng-container>

      <p-panel header="Unlisted documents (in no list for anyone — not a ladder effect)" [toggleable]="true"
               [collapsed]="unlistedCollapsed" (collapsedChange)="onUnlistedToggle($event)" styleClass="hidden-docs-unlisted">
        <div class="hidden-docs-unlisted-note">
          Uses the window and document types of the last Load; independent of the selected login and the ladder override.
          <span *ngIf="unlisted">Window shown here: from {{unlisted.window.fromDate}}{{unlisted.window.toDate ? ' to ' + unlisted.window.toDate : ''}}.</span>
          Repairing the missing rows is a data decision for the owner; this page only lists them.
        </div>

        <div *ngIf="unlistedLoading" class="hidden-docs-loading"><i class="pi pi-spin pi-spinner"></i> Loading…</div>

        <ng-container *ngIf="unlisted">
          <div class="hidden-docs-summary">
            <div>
              Documents in window: <strong>{{unlisted.summary.documentsInWindow | number}}</strong> ·
              listed: {{listedForUnlisted === null ? '…' : (listedForUnlisted | number)}} ·
              unlisted: <strong>{{unlisted.summary.unlisted | number}}</strong>
              <p-tag *ngIf="reconciles === true" severity="success" value="counts reconcile"></p-tag>
              <p-tag *ngIf="reconciles === false" severity="warning" value="counts differ"
                     pTooltip="documents in window should equal listed + unlisted; the two figures are separate reads, so documents added or changed in between can differ"></p-tag>
            </div>
            <div class="hidden-docs-chips">
              <p-tag *ngFor="let code of unlistedReasonCodes" [value]="reasonLabel(code) + ': ' + (unlisted.summary.byReason[code] | number)"
                     [pTooltip]="reasonTooltip(code)" severity="info"></p-tag>
            </div>
          </div>

          <p-table [value]="unlistedRows" [lazy]="true" [lazyLoadOnInit]="false" (onLazyLoad)="onUnlistedPage($event)" [loading]="unlistedLoading"
                   [paginator]="true" [rows]="unlistedRowsPerPage" [first]="unlistedFirst" [totalRecords]="unlisted.summary.unlisted"
                   [rowsPerPageOptions]="[25, 50, 100]" [showCurrentPageReport]="true"
                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords} unlisted documents"
                   styleClass="p-datatable p-datatable-gridlines p-datatable-striped" dataKey="DOCID" [rowHover]="true">
            <ng-template pTemplate="header">
              <tr>
                <th>Type</th>
                <th>Number (raw)</th>
                <th>Date</th>
                <th>Client id</th>
                <th>Contact id</th>
                <th>Author id</th>
                <th>Local company id</th>
                <th>Why unlisted</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-u>
              <tr>
                <td>{{docTypeName(u.DOCTYPEID)}} <p-tag *ngIf="isUnlistedVoided(u)" severity="danger" value="Voided"></p-tag></td>
                <td><a href="javascript:void(0)" (click)="openUnlistedDocument(u)">{{u.DOCNUMBER}}</a></td>
                <td>{{u.DOCDATE | date:'dd.MM.yyyy'}}</td>
                <td>{{u.DOCCLIENTSID}}</td>
                <td>{{u.DOCPERSONID}}</td>
                <td>{{u.DOCMANPERID}}</td>
                <td>{{u.DOCLCOCLIID}}</td>
                <td>
                  <p-tag *ngFor="let code of u.reasons" [value]="reasonLabel(code)" [pTooltip]="reasonTooltip(code)" severity="warning" styleClass="hidden-docs-chip"></p-tag>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr><td colspan="8">No unlisted documents in this window.</td></tr>
            </ng-template>
          </p-table>
        </ng-container>
      </p-panel>
    </ng-container>
  </ng-container>
</div>
